import { apiPostForm } from "./http";
import { getApiErrorMessage, isApiError } from "./errors";

/**
 * 租户侧图片仅通过 `/api/tenants/{id}/storage/upload-image` 落对象存储（OSS）。
 * `purpose` 为 tenantLogo / enrollmentAgreementSeal / agreementSignature 时服务端跳过微信图片安全审核。
 * 未配置存储或服务错误时抛错，由调用方提示用户，不生成 Base64 以免运维与排障不统一。
 */
export async function uploadTenantImageFile(
  file: File,
  tenantLegacyId: string,
  purpose?: string,
): Promise<string> {
  const tid = tenantLegacyId.trim();
  if (!tid) throw new Error("缺少租户 ID");
  const fd = new FormData();
  fd.append("file", file);
  const p = purpose?.trim();
  if (p) fd.append("purpose", p);
  try {
    const r = await apiPostForm<{ url: string }>(`/api/tenants/${tid}/storage/upload-image`, fd);
    return r.url;
  } catch (e) {
    const raw = getApiErrorMessage(e);
    if (
      (isApiError(e) && e.status === 503) ||
      raw.includes("OSS 未配置") ||
      raw.includes("503")
    ) {
      throw new Error("图片存储未就绪：请配置对象存储（OSS）后重试，或联系管理员。");
    }
    throw e instanceof Error ? e : new Error(raw || "图片上传失败");
  }
}

/** 画布/签名等 data URL：仅作字节来源，仍只走 upload-image。 */
export async function uploadTenantImageFromDataUrl(dataUrl: string, tenantLegacyId: string): Promise<string> {
  const blob = await (await fetch(dataUrl)).blob();
  const file = new File([blob], "image.png", { type: blob.type || "image/png" });
  return uploadTenantImageFile(file, tenantLegacyId);
}
